import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// The "Bookings" sidebar badge shows how many bookings are PENDING right now —
// there's no per-item "read" flag on a booking, so instead we remember the
// pending total as of the admin's last visit to the Booking List page and only
// badge the difference (new pending bookings since then). Visiting the page
// again re-syncs it to the current total, which is what makes the badge "go
// away" once it's been checked.
interface BookingsSeenState {
  seenPendingCount: number
  markPendingSeen: (count: number) => void
}

export const useBookingsSeenStore = create<BookingsSeenState>()(
  persist(
    (set) => ({
      seenPendingCount: 0,
      markPendingSeen: (count) => set({ seenPendingCount: count }),
    }),
    { name: 'drivys-bookings-seen' }
  )
)
